import { Action, Result } from '../../index';
import { DEFAULT_CORRELATION_VALUES } from '../../../utils/constants';
import { calculateComparisonCorrelations } from '../../../utils/comparison';

// Types
import { ComparisonCorrelationState } from '../types/comparison-correlations';

const INITIAL_STATE = DEFAULT_CORRELATION_VALUES;

// Actions
const CLEAR: Action = {
  type: 'connect/comparison-correlations/clear',
};
const SET: Action = {
  type: 'connect/comparison-correlations/set',
};

// Reducer
export default function reducer(state: ComparisonCorrelationState = INITIAL_STATE, action: Action): ComparisonCorrelationState {
  switch (action.type) {
    case CLEAR.type: {
      return INITIAL_STATE;
    }
    case SET.type: {
      return action.correlations;
    }
    default: {
      return state;
    }
  }
}

// Action Creators
export const setComparisonCorrelations = (): Result<void> => (dispatch, getState) => {
  const currentComparison = getState().comparison.activeComparison;

  if (currentComparison) {
    const correlations = calculateComparisonCorrelations(currentComparison);
    dispatch({ ...SET, correlations });
  }
};
